import { history } from 'umi';
import type { ITopChartsTypeOfCompanies } from '../components/CompaniesCore/types';
import { has, get, set, cloneDeep, constant } from 'lodash-es';
import { topchartCompaniesRevenueValidCfg } from '@intelligence/_config/urlPageValidCfg';
import { URL_SORT_NAME, ShortLinkPageValidCfgType } from '@intelligence/utils/urlPathCfg';
import { getRevenueTableList } from '@intelligence/pages/TopCharts/Companies/components/CompaniesCore/components/Tables/utils';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const COMPANY_IPO_STATUS_LOCALE_KEYS: {
  [key: string]: string;
} = {
  Public: 'dbi_company_public',
  Private: 'dbi_company_private',
  Delisted: 'dbi_company_delisted',
};

export const updatePathURLByPageId = (topChartsType: ITopChartsTypeOfCompanies) => {
  let path = `/intelligence/topCharts/companies/${topChartsType}`;
  history.replace(path);
};


const UNIT_LIST = [
  { value: 10 ** 3, text: 'K' },
  { value: 10 ** 6, text: 'M' },
  { value: 10 ** 9, text: 'B' }
]

export const tranFormRevenueRangeParams = (params:any)=> {
  if(!params) return {};
  const cloneParams = cloneDeep(params);
  if(!has(cloneParams, 'revenue_range_unit')) return params;

  const minValue = get(cloneParams, 'revenue_range_unit.min.value', '');
  const maxValue = get(cloneParams, 'revenue_range_unit.max.value', '');
  const minUnit = get(cloneParams, 'revenue_range_unit.min.unit', '');
  const maxUnit = get(cloneParams, 'revenue_range_unit.max.unit', '');

  let revenueFilter: any = [];
  if (minValue|| minValue === 0) {
    const unitValue = UNIT_LIST?.find(item=> item.text === minUnit)?.value || 1;
    revenueFilter.push({
      metric: 'total_revenue',
      opt: '>=',
      value: Number(minValue) * unitValue,
    });
  }
  if (maxValue || maxValue === 0) {
    const unitValue = UNIT_LIST?.find(item=> item.text === maxUnit)?.value || 1;
    revenueFilter.push({
      metric: 'total_revenue',
      opt: maxValue === 0? '<=': '<',
      value: Number(maxValue) * unitValue,
    });
  }

  delete cloneParams.revenue_range_unit;
  if(revenueFilter?.length){
    set(cloneParams, 'metric_filter.total', revenueFilter);
  }
  return cloneParams;
}

export const getRevenuePageValidCfg = (urlFilter?: any): ShortLinkPageValidCfgType => {
  // 获取表格有效列表值 
  const tableList: any[] = getRevenueTableList(urlFilter?.[filterKeyMap.GAME_TYPE]?.value);
  const currentValidCfg: ShortLinkPageValidCfgType = {
    ...topchartCompaniesRevenueValidCfg,
    // 更新表格排序
    [URL_SORT_NAME]: tableList?.map(t => t?.key),
  };
  return currentValidCfg
}